import React, { useState } from 'react';
import { Formik } from 'formik';
import SelectDropdown from '../../../../../components/common-components/selectDropdown';
import {
	ABHA_HEALTH_RECORD_FIELDS,
	MEDICATION_ADDITIONAL_INSTRUCTION,
	MEDICATION_REQUEST_INTENT,
	MEDICATION_REQUEST_STATUS,
	MEDICATION_ROUTE_OPTIONS,
	DOSAGE_INSTRUCTION_OPTIONS,
} from '../Constants';
import Input from '../../../../../components/common-components/input/Input';
import Button from '../../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../../components/common-components/button/Constants';
import ItemManager from '../ItemManager';
import { v4 as uuidv4 } from 'uuid';
import Observation from './observation';
import ModalComponent from '../../../../../components/common-components/modal/ModalComponent';
import HealthRecordHelper from '../utils/utils';

const MedicationRequest = ({ open, onConfirm, close }) => {
	const [observationList, setObservationList] = useState([]);
	const [isObservationPopupOpen, setIsObservationPopupOpen] = useState(false);
	const [observationError, setObservationError] = useState('');

	const validate = (values) => {
		const errors = {};
		if (!values.medicationStatus || values.medicationStatus.value === 'Select Status') {
			errors.medicationStatus = 'Please select Medication request status.';
		}
		if (!values.medicationIntent || values.medicationIntent.value === 'Select Intent') {
			errors.medicationIntent = 'Please select Medication intent.';
		}
		if (!values.medicationText || !values.medicationText.value) {
			errors.medicationText = 'Please select a medication';
		}
		if (!values.authorizedTime) {
			errors.authorizedTime = 'Please provide a authorized time';
		}
		if (!values.dosageInstruction || !values.dosageInstruction.value) {
			errors.dosageInstruction = 'Please select dosage instruction';
		}
		return errors;
	};

	return (
		<>
			<Formik
				initialValues={{
					medicationStatus: { label: 'Select Status', value: 'Select Status' },
					medicationIntent: { label: 'Select Intent', value: 'Select Intent' },
					medicationText: { label: '', value: '' },
					authorizedTime: '',
					medicationReason: '',
					dosageInstruction: { label: '', value: '' },
					additionalInstruction: '',
					route: { label: '', value: '' },
					method: '',
					duration:'',
				}}
				validate={validate}
				onSubmit={(values) => {
					const data = {
						resourceType: ABHA_HEALTH_RECORD_FIELDS.MEDICATION_REQUEST.split(' ').join(''),
						status: values.medicationStatus.value,
						intent: values.medicationIntent.value,
						medicationText: values.medicationText.value,
						authoredOn: values.authorizedTime,
						reasonCode: values.medicationReason,
						reasonReference: observationList.map((item) => item.data),
						dosageInstructionText: values.dosageInstruction.value,
						additionalInstruction: HealthRecordHelper.removeEmptyFields({code: values.additionalInstruction.value, display: values.additionalInstruction.label}),
						route: values.route.value,
						method: values.method,
						duration:{
							value: values.duration,
							unit: "days",
							system: "http://unitsofmeasure.org",
							code: "d"
						}    
					};
					const formattedData = HealthRecordHelper.removeEmptyFields(data);
					console.log("Formatted DAt", formattedData)
					onConfirm((prev) => [
						...prev,
						{ type: `Medication Report ${prev.length + 1}`, medicationRequestReport: formattedData },
					]);
					close();
				}}
			>
				{({ values, errors, setFieldValue, handleSubmit }) => (
					<ModalComponent
                        open={open}
                        title={"Add Medication"}
                        footerButton={
                            <Button
                                variant={BUTTON_VARIANTS.CONTAINED} 
                                onClickCb={() => handleSubmit()}
                            >
                                Submit
                            </Button>
                        }
                        close={() => close()}
                        customClasses="w-[90%] max-w-[800px]"
                        customBodyClasses="overflow-visible" 
                    >
							<form onSubmit={handleSubmit} className="flex flex-col gap-4">
								<div className=" grid grid-cols-2 gap-2">
									<SelectDropdown
										label="Medication Status"
										name="medicationStatus"
										isRequired={true}
										customClasses="w-full"
										value={values.medicationStatus}
										options={[
											{ label: 'Select Status', value: 'Select Status' },
											...MEDICATION_REQUEST_STATUS,
										]}
										onChangeCb={(selectedOption) =>
											setFieldValue('medicationStatus', selectedOption)
										}
									/>
									<SelectDropdown
										label="Medication Intent"
										name="medicationIntent"
										isRequired={true}
										customClasses="w-full"
										value={values.medicationIntent}
										options={[
											{ label: 'Select Intent', value: 'Select Intent' },
											...MEDICATION_REQUEST_INTENT,
										]}
										onChangeCb={(selectedOption) =>
											setFieldValue('medicationIntent', selectedOption)
										}
									/>
									<SelectDropdown
										label="Medication Text"
										placeholder="Select medication"
										name="medicationText"
										isRequired={true}
										value={values.medicationText}
										url="master/medication"
										extractKeyFromResponse="medications"
										labelKey="name"
										valueKey="name"
										isAsync={true}
										onChangeCb={(selectedOption) => setFieldValue('medicationText', selectedOption)}
									/>
									<Input
										label="Authorized Time"
										name="authorizedTime"
										type="datetime-local"
										isRequired={true}
										value={values.authorizedTime}
										onChangeCb={(e) => setFieldValue('authorizedTime', e.target.value)}
									/>
									<Input
										label="Medicine Duration"
										name="duration"
										type="number"
										placeholder="Medicine Duration in Days"
										value={values.duration}
										onChangeCb={(e) => setFieldValue('duration', e.target.value)}
									/>
									<Input
										label="Reason"
										name="medicationReason"
										type="text"
										placeholder="Reason or indication for ordering or not ordering the medication"
										value={values.medicationReason}
										onChangeCb={(e) => setFieldValue('medicationReason', e.target.value)}
									/>
									<div className="mt-2 col-span-2">
										<ItemManager
											key={`medicationObservation_${uuidv4()}`}
											title={'Reason reference'}
											items={observationList}
											setItems={setObservationList}
											setIsPopupOpen={setIsObservationPopupOpen}
											customHeight="44"
										/>
									</div>
									<SelectDropdown
										label="Dosage Instruction"
										name="dosageInstruction"
										isRequired={true}
										placeholder="Select dosage instruction"
										value={values.dosageInstruction}
										options={DOSAGE_INSTRUCTION_OPTIONS}
										onChangeCb={(selectedOption) => setFieldValue('dosageInstruction', selectedOption)}
									/>
									{/* <Input
										label="Additional Instruction"
										name="additionalInstruction"
										type="text"
										placeholder="Additionala dosage instructions"
										value={values.additionalInstruction}
										onChangeCb={(e) => setFieldValue('additionalInstruction', e.target.value)}
									/> */}
									<SelectDropdown
										label={"Additional Instruction"}
										name="additionalInstruction"
										placeholder="Select"
										value={values.additionalInstruction}
										options={MEDICATION_ADDITIONAL_INSTRUCTION}
										onChangeCb={(selectedOption) =>
											setFieldValue('additionalInstruction', selectedOption)
										}
									/>
									<SelectDropdown
										label="Route"
										name="route"
										placeholder="Select route"
										value={values.route}
										options={MEDICATION_ROUTE_OPTIONS}
										openDirection="top"
										onChangeCb={(selectedOption) => setFieldValue('route', selectedOption)}
									/>
									<Input
										label="Method"
										name="method"
										type="text"
										placeholder="Dosage instruction method"
										value={values.method}
										onChangeCb={(e) => setFieldValue('method', e.target.value)}
									/>
								</div>
							</form>
					</ModalComponent>
		
				)}
			</Formik>
			{isObservationPopupOpen && (
				<Observation
					key={`medication${uuidv4()}`}
					onConfirm={setObservationList}
					setObservationError={setObservationError}
					close={() => setIsObservationPopupOpen(false)}
					isNested={true}
				/>
			)}
		</>
	);
};
export default MedicationRequest;
